<template>
    <div class="result">
        <div class="result-content">
              <div class="result-total">{{this.list.projectName}}{{this.list.announceType}}</div>
              <div style="text-align: center;margin-top: 10px;font-size: 18px;font-weight: 300;">发布时间: 2022-12-05 16:00:30</div>
              <div style="height: 1px; background-color: #F3F3F3 ;width: 100%;margin-top: 15px;"></div>
              <div class="result-statue">
                 <div class="result-content-item1">一, 项目名称: 12155</div>
                 <div class="result-content-item1">二, 项目编号: 222</div>
                 <div class="result-content-item1">三, 中标(成交)信息: 222</div>
                 <div class="result-content-item">
                     <div style="margin-top:20px">A</div>
                     <Form :model="list" label-position="right" :label-width="100">
                        <FormItem label="供应商名称:">
                            {{list.proUnit}}
                        </FormItem>
                        <FormItem label="供应商地址:">
                            {{list.proLocation}}
                        </FormItem>
                        <FormItem label="中标(成交)金额:">
                            {{list.projectContact}}
                        </FormItem>
                        
                 </Form>
                 </div>
                <div class="result-content-item1">四, 主要的标信息: 222</div>
                 <div class="result-content-item">
                     
                     <div style="margin-top:20px">
                        <Table :columns="columns"  border></Table>
                     </div>
                 </div>
                 <div class="result-content-item1">五, 评审专家名单</div>

                 <div class="result-content-item1">六, 公告期限</div>
                 <!-- <div class="result-content-item">1.发售时间: {{this.list.flowSubmitTime.substring(0,10)}}~{{this.list.flowFinishTime.substring(0,10)}}</div> -->
                 <div class="result-content-item">【结果公告发布日期】~【结果公告结束日期】</div>
                 
                 
                 <div class="result-content-item1">七, 其他补充事宜</div>
                 <div class="result-content-item">【公告说明】</div>


                 <div class="result-content-item1">六, 凡对本项目提出询问，请按一下联系方式联系</div>
                 <div class="result-content-item">1.采购人信息</div>

                 <Form :model="list" label-position="right" :label-width="100">
                        <FormItem label="名称:">
                            {{list.proUnit}}
                        </FormItem>
                        <FormItem label="地点:">
                            {{list.proLocation}}
                        </FormItem>
                        <FormItem label="联系人:">
                            {{list.projectContact}}
                        </FormItem>
                        <FormItem label="电话:">
                            {{list.proContactUs}}
                        </FormItem>
                 </Form>
                 <div class="result-content-item">2.采购代理机构信息</div> 
                 <Form :model="list" label-position="right" :label-width="100">
                        <FormItem label="名称:">
                            {{list.tenderAgencyName}}
                        </FormItem>
                        <FormItem label="地点:">
                            {{list.tenderAgencyLocation}}
                        </FormItem>
                        <FormItem label="联系人:">
                            {{list.tenderAgencyContact}}
                        </FormItem>
                        <FormItem label="电话:">
                            {{list.tenderAgencyContactUs}}
                        </FormItem>
                 </Form>
                 <div class="result-content-item1">相关附件</div>
              </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'inform',
    data(){
        return{
            columns: [
                    {
                        title: '序号',
                        key: 'number',
                        resizable: true,
                        width: 180
                    },
                    {
                        title: '采购需求',
                        key: 'need',
                        resizable: true,
                        width: 280
                    },
                    {
                        title: '计量单位',
                        key: 'measure',
                        resizable: true,
                        width: 280
                    },
                    {
                        title: '是否接受进口产品',
                        key: 'import',
                        resizable: true,
                        width: 280
                    },
                    {
                        title: '预算金额(万元)(人民币)',
                        key: 'money',
                    }
                ],
                id:'',
                address:'',
                billdefine:'',
                list:{}
        }
    },
    created(){
        GMS.vbus.$on('on-result-change',(res)=>{
            this.id = res.id
            this.billdefine = res.billdefine
            this.address = res.ip
            // this.getResult()
        })
    },
    mounted(){},
    methods:{
        getResult() {
            // let pram = { id: this.id,billdefine: this.billdefine }
            GMS.$http.post('/portal/information', {
                 data:  this.address + '/portal/announce/'+this.billdefine+'/'+this.id
            }).then(res => {
                if (res.status == 200) {
                    this.list = res.data.content
                }
            }).catch(error => {
                this.$Message.error("获取数据异常，请联系管理员");
            })
        }
    }
}
</script>

<style lang="less" scoped>
.result{
    width: 100%; 
    
    margin-top: 60px;
}
.result-content{
    margin: 0 auto;
    width: 1200px;
}
@media screen and (max-width:1500px){
    .result-content{
        width: 1200px;
    }
}
@media screen and (min-width:1500px) and (max-width:1800px){
    .result-content{
        width: 1400px;
    }
}
@media screen and (min-width:1800px){
    .result-content{
        width: 1600px;
    }
}
.result-total{
    text-align: center;
    font-size: 28px;
    font-weight: 400;
}
.result-statue{
   margin-left: 160px;
}
.result-content-item{
    margin-left: 30px;
}
.result-content-item1{
   font-size: 20px;
   font-weight: 400;
   margin-top: 20px; 
}
.ivu-form-item{
    margin-bottom: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/inside/inform.vue